import { render, staticRenderFns } from "./travel_quota.vue?vue&type=template&id=1b7f0477&"
import script from "./travel_quota.vue?vue&type=script&lang=js&"
export * from "./travel_quota.vue?vue&type=script&lang=js&"
import style0 from "./travel_quota.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports